import type { Theme } from "@mui/material";

export default function getPopperOverrides(theme: Theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundImage: "none",
          borderRadius: 8,
          "& .MuiMenu-list": {
            padding: 0,
          },
        },
        root: {
          marginTop: theme.spacing(1),
        },
      },
    },
  };
}
